import type { Doc } from "building-types/doc";
import { docEntityGetComponent } from "./entity/docGetEntityComponent";

/**
 * Get the component id (or undefined for the main world) for a level.
 */
export function docGetLevelWorldId(doc: Pick<Doc, "componentMembers">, levelId: string): string | undefined {
  return docEntityGetComponent(doc, { type: "LEVEL", id: levelId })?.id;
}

/**
 * Get the component id (or undefined for the main world) for a block.
 */
export function docGetBlockWorldId(doc: Pick<Doc, "componentMembers">, blockId: string): string | undefined {
  return docEntityGetComponent(doc, { type: "BLOCK", id: blockId })?.id;
}

/**
 * Counts levels in the same world as the given level.
 */
export function docCountLevelsInWorld(doc: Doc, worldId: string | undefined): number {
  let count = 0;
  for (const id in doc.levels) {
    if (docGetLevelWorldId(doc, id) === worldId) {
      count++;
    }
  }
  return count;
}

/**
 * Counts blocks in a world given component id (or undefined for the main world).
 */
export function docCountBlocksInWorld(doc: Doc, worldId: string | undefined): number {
  let count = 0;
  for (const id in doc.blocks) {
    if (docGetBlockWorldId(doc, id) === worldId) {
      count++;
    }
  }
  return count;
}
